import usePendoId from '@ob/hooks/usePendoId';

export default function useTilePendoId() {
  return usePendoId({ prefix: ['goalTile'] });
}
